import React, { Component, Fragment }from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import slug from 'slug'

import '../styles/youtuberepeater.scss'

class YoutubeRepeater extends Component {
  constructor(props) {
    super(props);
    this.onChangeYoutubeUrl = this.onChangeYoutubeUrl.bind(this);
    this.onGenerateYoutubePlayer = this.onGenerateYoutubePlayer.bind(this);
    this.state = {
      youtubeUrl: '',
      youtubePlayerDOM: ''
    };
  }

  onChangeYoutubeUrl(e) {
    const value = e.target.value;
    this.setState({
      youtubeUrl: value,
    });
  }

  onGenerateYoutubePlayer() {
    if (this.state.youtubeUrl !== '') {
      const youtubeID = this.extractYoutubeID(this.state.youtubeUrl);

      this.setState({
        youtubePlayerDOM: `<iframe width="560" height="315" src="https://www.youtube.com/embed/${youtubeID}?autoplay=1&loop=1&playlist=${youtubeID}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`
      }, () => {
        console.log(this.state.youtubePlayerDOM)
      })
    }
  }

  extractYoutubeID(url) {
    const match =  url.match(/(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^\?&"'>]+)/);

    if (match && match[5]) {
      return match[5];
    }

    return '';
  }

  render() {
    const { data } = this.props;
    return (
      <div className="YoutubeRepeater">
        <Helmet
          title={`YoutubeRepeater - ${data.site.siteMetadata.title}`}
          meta={[
            { name: 'description', content: 'Sample' },
            { name: 'keywords', content: 'sample, something' },
          ]}
        />
        <h2>Enter a Youtube URL and the video will be repeated indefinitely</h2>
        <input 
          type="text" 
          value={this.state.youtubeUrl}
          placeholder="https://www.youtube.com/watch?v=YHIieMoFLjE"
          onChange={this.onChangeYoutubeUrl}  
        />
        <button
          onClick={this.onGenerateYoutubePlayer}
        >Repeat!</button>

        <div dangerouslySetInnerHTML={{__html: this.state.youtubePlayerDOM}} />
      </div>
    )
  }

}

YoutubeRepeater.propTypes = {

}

export default YoutubeRepeater;

export const query = graphql`
  query YoutubeRepeaterTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/youtuberepeater.js